import { createContext, ReactNode, memo } from 'react'
import { TConnects, createUseSocket, createUseSocketListener } from '../createWebSocket'
import getSocketMessageIdAndData, { generateMessageId, sendMessageHandler } from './getContractSocketMessageIdAndData'
import { useWebSocketURL } from '../useWebSocketURL'

const ContractSocketContext = createContext<TConnects | undefined>(undefined)

const sendPingHandler = (socket: WebSocket) => {
  socket.send(
    JSON.stringify({
      event: 'ping',
    })
  )
}

type TSocketProviderProps = {
  children: ReactNode
}
export const ContractSocketProvider = memo(({ children }: TSocketProviderProps) => {
  const { contractWsURL: wsURL } = useWebSocketURL()
  return (
    <ContractSocketContext.Provider
      value={{
        wsURL,
        subscribeData: {},
        socket: null,
        getSocketMessageIdAndData,
        generateMessageId,
        sendMessageHandler,
        sendPingHandler,
      }}
    >
      {children}
    </ContractSocketContext.Provider>
  )
})

ContractSocketProvider.displayName = 'ContractSocketProvider'

export const useContractSocket = createUseSocket(ContractSocketContext)
export const useSocketListener = createUseSocketListener(ContractSocketContext)
